import React, { useCallback, useState } from 'react';
import { Select } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import {
  ISearchShippingAddressReq,
  ISearchShippingAddressRes,
  IShippingAddress,
} from '@/interfaces/shipping-address';
import { AxiosResponse } from 'axios';
import { searchShippingAddresss } from '@/adapters/shipping-address';
import { debounce } from 'lodash';

interface IProps {
  customerId?: number;
  value?: number;
  size?: SizeType;
  isAll?: boolean;
  handleSelectData: (id: number, item?: IShippingAddress) => void;
  readonly?: boolean;
}

const _criteria: ISearchShippingAddressReq = {
  orderBy: 'id',
  orderType: 'descend',
  pageSize: 40,
  pageStart: 1,
  search: '',
  entryName: 'customer',
};

const ShippingAddressSelector = ({
  customerId,
  value,
  size = 'large',
  handleSelectData,
  isAll = false,
  readonly,
}: IProps) => {
  const [criteria, setCriteria] = useState<ISearchShippingAddressReq>({
    ..._criteria,
  });

  const { data: shiptos, isLoading } = useQuery<
    AxiosResponse<ISearchShippingAddressRes>,
    Error
  >({
    queryKey: ['search-shipping-address', criteria, customerId],
    queryFn: async () =>
      await searchShippingAddresss({ ...criteria, entryId: customerId }),
    enabled: !!customerId,
  });

  const groupOptions =
    shiptos?.data?.data?.map(g => {
      return {
        value: g.id,
        label: `${g.shortName}` || `${g.name}`,
      };
    }) || [];

  const allOptions = [{ value: '', label: 'ทั้งหมด' }, ...groupOptions];

  const debouncedSearch = useCallback(
    debounce(value => {
      setCriteria({
        ...criteria,
        search: value,
      });
    }, 300),
    [],
  );

  const onBeforeSelectData = (id: number) => {
    const find = shiptos?.data?.data?.find(s => s.id === id);
    handleSelectData(id, find);
  };

  return (
    <Select
      allowClear
      showSearch
      onSearch={debouncedSearch}
      loading={isLoading}
      value={value}
      className="md:min-w-[150px] w-full"
      size={size}
      placeholder="เลือกที่จัดส่ง"
      onChange={value => onBeforeSelectData(value)}
      options={isAll ? allOptions : [...groupOptions]}
      filterOption={(input, option) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
      }
      disabled={readonly}
    />
  );
};

export default ShippingAddressSelector;
